/* src/features/5DD/StartCourse.js */
import React from 'react';

const styles = {
  container: {
    display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
    height: '100vh', padding: '20px', color: '#fff', textAlign: 'center'
  },
  title: { fontSize: '2.5em', marginBottom: '20px', color: '#b08d6d' },
  subtitle: { fontSize: '1.1em', marginBottom: '40px', maxWidth: '400px', lineHeight: '1.5' },
  button: {
    padding: '15px 40px', fontSize: '1.2em', backgroundColor: '#b08d6d', color: '#fff',
    border: 'none', borderRadius: '30px', cursor: 'pointer', fontWeight: 'bold',
    boxShadow: '0 4px 15px rgba(176, 141, 109, 0.4)', transition: 'transform 0.2s',
    marginBottom: '20px'
  },
  historyButton: {
    padding: '10px 20px', fontSize: '1em', backgroundColor: 'transparent', color: '#aaa',
    border: '1px solid #555', borderRadius: '30px', cursor: 'pointer',
    transition: 'all 0.2s'
  }
};

function StartCourse({ onStart, onViewHistory }) { // <--- Added onViewHistory prop
  return (
    <div style={styles.container}>
      <h1 style={styles.title}>Five Days Different</h1>
      <p style={styles.subtitle}>
        A 5-day cycle to reset your habits, clear your mind, and rebuild your rhythm.
      </p>
      
      <button style={styles.button} onClick={onStart}>
        Begin New Cycle
      </button>

      {/* New History Button */}
      <button style={styles.historyButton} onClick={onViewHistory}>
        View Past Courses
      </button>
    </div>
  );
}

export default StartCourse;